import { motion } from "framer-motion";
import { OFFERINGS } from "@/constants/site";
import { OFFERINGS_IDS } from "@/constants/testIds";

const Offerings = () => {
  return (
    <section
      data-testid={OFFERINGS_IDS.root}
      className="section-rule bg-black py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-4">
          <div className="num-tag mb-4">/ CHAPTER 03 · MEDIA & BRAND</div>
          <motion.h2
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display uppercase text-5xl md:text-6xl leading-[0.9] tracking-tight"
          >
            The camera
            <br />
            <span className="stroke-fire">tells the truth.</span>
          </motion.h2>
          <p className="mt-6 text-zinc-400 max-w-[38ch] text-base md:text-lg leading-relaxed">
            Every rep is a story. We produce the assets that get an athlete
            seen — from the sideline to the sponsor deck.
          </p>
        </div>

        <div className="md:col-span-8">
          <ul className="border-t border-white/10">
            {OFFERINGS.map((o, i) => (
              <motion.li
                key={o}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.7,
                  delay: 0.06 * i,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="group flex items-baseline justify-between border-b border-white/10 py-6 md:py-8 cursor-default"
              >
                <div className="flex items-baseline gap-6 md:gap-8">
                  <span className="font-mono-plex text-xs tracking-[0.28em] text-zinc-500">
                    /0{i + 1}
                  </span>
                  <span className="font-display uppercase text-3xl md:text-5xl leading-none tracking-tight group-hover:text-[#FF4D00] transition-colors">
                    {o}
                  </span>
                </div>
                <span className="font-mono-plex text-[11px] tracking-[0.28em] text-zinc-500 uppercase hidden sm:block">
                  Included
                </span>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Offerings;
